// extracted by css-extract-rspack-plugin
export default {"entityHistory":"ArticlePreview_entityHistory__kwHch"};